"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NavSearch = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _icons = require("@ant-design/icons");

var _utils = _interopRequireDefault(require("../../../utils"));

var _SearchInput = _interopRequireDefault(require("./SearchInput"));

var NavSearch = function NavSearch(props) {
  var active = props.active,
      close = props.close,
      headerNavColor = props.headerNavColor;

  var mode = _utils.default.getColorContrast(headerNavColor);

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "nav-search ".concat(active ? 'nav-search-active' : '', " ").concat(mode),
    style: {
      backgroundColor: headerNavColor
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex align-items-center w-100"
  }, /*#__PURE__*/_react.default.createElement(_SearchInput.default, {
    close: close,
    active: active
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "nav-close",
    onClick: close
  }, /*#__PURE__*/_react.default.createElement(_icons.CloseOutlined, null)));
};

exports.NavSearch = NavSearch;

var mapStateToProps = function mapStateToProps(_ref) {
  var theme = _ref.theme;
  var headerNavColor = theme.headerNavColor;
  return {
    headerNavColor: headerNavColor
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, {})(NavSearch);

exports.default = _default;